import { render } from "./AlloyView.vue?vue&type=template&id=7c7aa90b"
import script from "./AlloyView.vue?vue&type=script&lang=js"
export * from "./AlloyView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__